import { href, useSearchParams } from "react-router-dom"
import { Popup } from "./popup"
import React, { useEffect, useState } from "react"
import { getLanguage, localize, localizePrice } from "../../../common/services/localization"
import { isNothing } from "../../../common/utils"
import { ProductImage, SizedImage } from "../ui/file-contents"
import { Product } from "../../../api/repositories/stats/models/products"
import { ProductsRepository } from "../../../api/repositories/stats/products"
import { SubscribeGlobalState } from "../../../common/hooks/global-state"
import { PaymentsRepository } from "../../../api/repositories/backend/payments"
import { OrangeButton, SwitchWithValuesBtn } from "../functional/buttons"
import { Input } from "../functional/inputs"
import { Table } from "../ui/tables"
import { PresentsHistoryResponse } from "../../../api/repositories/backend/models/payments"

export const PresentPopup: React.FC<{
    type: PresentPopupPage
}> = ({ type }) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const [stage, setStage] = useState("main" as PresentPopupPageStage)
    const [presentPopupPage, setPresentPopupPage] = useState(type)

    useEffect(() => {
        if (getLanguage() !== "ru") {
            clearSearchParams(searchParams)
            setSearchParams(searchParams);
        }
    }, []);

    let bodyBlock;
    let allHeaders = ['buy', 'history'] as PresentPopupPage[];

    switch (presentPopupPage) {
        case "buy":
            switch (stage) {
                case "main":
                    bodyBlock = <PresentBuyMainStagePopup
                        onOrderCreate={(orderId, url) => {
                            setStage("order_wait");
                            window.open(url);
                        }}
                    />
                    break;
                case "order_wait":
                    bodyBlock = <PresentBuyOrderWaitStagePopup />
                    break;
            }

            break;
        case "history":
            bodyBlock = <PresentHistoryPopup />
            break;
    }

    return <Popup
        className="min-h-screen p-[0]"
    >
        <div className="min-w-[944px]">
            <div className={`flex flex-col lg:flex-row justify-center lg:gap-x-[80px] px-[10px] lg:px-[0]`}>
                {allHeaders.map((h, i) => (
                    <PresentHeaderPopup key={i} presentPopupPage={presentPopupPage} onSelect={() => setPresentPopupPage(h)} type={h} />
                ))}
            </div>
            {bodyBlock}
        </div>
    </Popup >
}


const PresentHeaderPopup: React.FC<{
    type: PresentPopupPage,
    onSelect: any,
    presentPopupPage: PresentPopupPage
}> = ({ type, onSelect, presentPopupPage }) => {

    let titleLocalize;

    switch (type) {
        case "buy":
            titleLocalize = "buy_present_buy_title"
            break;
        case "history":
            titleLocalize = "buy_present_history_title"
            break;
    }

    const isActive = type == presentPopupPage;

    return <div className={`mb-[10px] lg:mb-[20px] ${isActive ? 'text-orange' : 'text'} 
    cursor-pointer justify-start text-[24px] lg:text-[32px] font-semibold font-['Reaver'] uppercase tracking-wider`}
        onClick={() => onSelect(type)}
    >
        <span className={`${isActive ? "opacity-[1]" : "opacity-[0.2]"}`}>
            {localize(titleLocalize)}
        </span>
    </div>
}

const PresentBuyMainStagePopup: React.FC<{
    onOrderCreate: (orderId: number, url: string) => any
}> = ({ onOrderCreate }) => {
    const currency = 'rub' as Currency
    const paymentsRepository = new PaymentsRepository();

    const [productsResponse, setProductsResponse] = useState<ApiDataResponse<Product[]>>()

    const [isCoupon, setIsCoupon] = React.useState(false);
    const [isBtnActive, setIsBtnActive] = React.useState(false);
    const [giftPlayerId, setGiftPlayerIdState] = React.useState(null as any);
    const [giftMessage, setGiftMessageState] = React.useState('');
    const [selectedProduct, setSelectedProduct] = React.useState({} as Product);


    useEffect(() => {
        const respository = new ProductsRepository();
        respository.getAll()
            .then(t => setProductsResponse(t))
    }, [])

    function setGiftPlayerId(event: any) {
        let val = event.target.value.trim() as string;
        val = val.substring(0, 12);

        setGiftPlayerIdState(val);
        setIsBtnActive(val.length >= 8 && val.length <= 12 && !isNothing(selectedProduct?.productId));
    }

    function trySetSelectedProduct(product: Product) {
        setSelectedProduct(product);

        const isProductValid = !isNothing(product?.productId);

        if (isCoupon)
            setIsBtnActive(isProductValid);
        else {
            setIsBtnActive(isProductValid && giftPlayerId?.length >= 8 && giftPlayerId?.length <= 12);
        }
    }

    function setGiftMessage(event: any) {
        let val = event.target.value as string;
        val = val.substring(0, 140);

        setGiftMessageState(val);
    }

    function switchTongle() {
        setSelectedProduct({} as Product);
        setGiftPlayerIdState(null);
        setIsBtnActive(false);
        setIsCoupon(!isCoupon);
    }

    return productsResponse
        ? productsResponse.data
            ? <div className="flex flex-col gap-[16px]">
                <div className="flex w-screen lg:w-full px-[10px] lg:px-[0]">
                    <SwitchWithValuesBtn
                        classNames="font-['Roboto']"
                        leftValue={localize("buy_present_gift_type")}
                        rigthValue={localize("buy_present_coupon_type")}
                        isOn={isCoupon}
                        handleToggle={() => switchTongle()}
                    />
                </div>
                {
                    isCoupon
                        ? <></>
                        : <div className="flex flex-col gap-[8px] px-[10px] lg:px-[0]">
                            <Input
                                className="w-screen lg:w-full"
                                placeholderLocal="buy_present_gift_player_id"
                                type="number"
                                defaultValue=""
                                value={giftPlayerId || undefined}
                                onChange={(e) => setGiftPlayerId(e)}
                            />
                            <Input
                                className="w-screen lg:w-full"
                                value={giftMessage}
                                placeholderLocal="buy_present_gift_message"
                                onChange={(e) => setGiftMessage(e)}
                            />
                        </div>
                }
                <div className="grid grid-cols-2 lg:grid-cols-4 items-center gap-[12px] w-screen lg:w-full px-[10px] lg:px-[0]">
                    {productsResponse.data.map(s => <BuyPresentProductCard
                        product={s}
                        currency={currency}
                        onSelect={(product) => trySetSelectedProduct(product)}
                        selectedProduct={selectedProduct}
                    />
                    )}
                </div>
                <div>
                    {
                        <div className="text-[12px] text-gray font-['Roboto']">
                            {isCoupon
                                ? 'Чтобы принять подарок, получателю надо будет активировать промокод'
                                : 'Чтобы принять подарок, получателю надо будет зайти в матч в Dota 1x6. Подойдет лобби на 1 человека, но не локальный сервер'
                            }
                        </div>
                    }
                    <OrangeButton
                        className="py-[10px] w-screen lg:w-full"
                        localText={selectedProduct.productId
                            ? localize("buy_present_oplata_ready").replace("%price%", localizePrice(selectedProduct.prices[currency], currency))
                            : localize("buy_present_oplata_wait")
                        }
                        disabled={!isBtnActive}
                        onClick={() => {
                            paymentsRepository.createOrder({
                                currency: currency,
                                productId: selectedProduct.productId,
                                type: isCoupon ? "Coupon" : "Gift",
                                giftMessage: giftMessage,
                                giftPlayerId: giftPlayerId
                            }).then((response) => {
                                if (!response.hasErrors)
                                    onOrderCreate(response.data?.orderId!, response.data?.url!)
                                else
                                    alert(response.errors[0].text);
                            });
                        }}
                    />
                </div>
            </div>
            : null
        : null
}

const PresentBuyOrderWaitStagePopup: React.FC = () => {
    return <div className="flex flex-col items-center justify-center text-center font-semibold text-[18px] text-center uppercase h-[20vh]"
        dangerouslySetInnerHTML={{ __html: localize("buy_present_order_wait") }}
    >
    </div>
}

const BuyPresentProductCard: React.FC<{
    product: Product
    currency: Currency
    onSelect: (product: Product) => any,
    selectedProduct: Product
}> = ({ product, currency, onSelect, selectedProduct }) => {
    const discount = product.extraData?.discount?.toString() || ''
    const price = product.prices[currency].toString();
    const productName = product.productName;
    const productId = product.productId;
    const isActive = selectedProduct == product;

    let productTitle = '';

    switch (productName) {
        case "dota_plus":
            productTitle = localize(`buy_product_${productId}`);
            break;
        case "shards":
            productTitle = localize("buy_shards_product_desc").replace("%amount%", product.amount.toString());
            break;
    }

    return (
        <div key={product.productId} className={`flex flex-col items-center relative p-[6px] bg-dark-sm shadow-dark-sm gap-[6px] 
            ${isActive ? "opacity-[1]" : "opacity-[0.4] hover:opacity-[0.8]"} cursor-pointer`}
            onClick={() => onSelect(product)}
        >
            <div className="flex justify-center lg:w-[193px] lg:h-[120px]">
                <ProductImage
                    imgClassName="h-full"
                    name={productId}
                />
                {discount !== "" ?
                    <div className="absolute top-0 right-0 bg-green text-right px-[10px] py-[6px] 
                    font-['Roboto'] font-semibold text-[16px] w-auto">
                        {`-${discount}%`}
                    </div>

                    : <></>
                }
            </div>
            <div className="font-semibold uppercase"
                dangerouslySetInnerHTML={{
                    __html: productTitle
                }}
            >
            </div>
            <span className="font-['Roboto']">
                {localizePrice(price, currency)}
            </span>
        </div>
    )
}

export const PresentHistoryPopup: React.FC = () => {
    const [response, setResponse] = useState<ApiDataResponse<PresentsHistoryResponse[]>>()
    useEffect(() => {
        const paymentsRepository = new PaymentsRepository();

        paymentsRepository.getPresentsHistory()
            .then(t => setResponse(t))
    }, [])

    return <div className="flex lg:text-[16px] w-screen lg:w-full max-w-[940px]">
        <Table
            bodyClassName="font-normal text-[16px]"
            headClassName="text-[8px] lg:text-[16px]"
            needSeparate={true}
            cols={[
                { headLocalName: "buy_present_history_table_header_type", className: "w-[40px] lg:w-[130px] text-center pl-[18px]" },
                { headLocalName: "buy_present_history_table_header_promocode", className: "w-[40px] lg:w-[200px] text-center" },
                { headLocalName: "buy_present_history_table_header_created_at", className: "w-[40px] lg:w-[180px] text-center" },
                { headLocalName: "buy_present_history_table_header_consumer_player_id", className: "w-[40px] lg:w-[100px] text-center" },
                { headLocalName: "buy_present_history_table_header_consumer_at", className: "w-[40px] lg:w-[230px] text-center" },
            ]}
            rows={
                response
                    ? response.data
                        ? response.data.map((row) => ({
                            cols: [
                                { value: row.type == 2 ? "Подарок" : "Промокод", className: 'w-[40px] lg:w-[130px] text-center pl-[18px]' },
                                { value: row.code, className: 'w-[40px] lg:w-[200px] text-center ' },
                                { value: row.createdAt, className: 'w-[40px] lg:w-[180px] text-center ' },
                                { value: row.consumerPlayerId, className: 'w-[40px] lg:w-[100px] text-center' },
                                { value: row.usedAt, className: 'w-[40px] lg:w-[230px] text-center' },
                            ],
                        }))
                        : []
                    : []
            }
        />
    </div>
}

function clearSearchParams(params: URLSearchParams): URLSearchParams {
    params.delete("popup")
    params.delete("productId")
    params.delete("present")
    params.delete("present_history")

    return params;
}